<div class="modal-wrapper">
  <span class="title">Report received</span>
  <span class="p3">
    Thank you for helping us maintain a safe and 
    accurate environment. Our team will review this 
    content to ensure it meets clinical and community 
    standards.
  </span>

  <app-button
    title="Ok"
    [style]="'outlined stretch'"
    size="small"
    (onCLick)="onClose.next()"
  ></app-button>
</div>